import { combineReducers } from 'redux'

// reducers
import paymentMethod from './paymentMethod'
import paymentProfileForm from './paymentProfileForm'

const reducer = combineReducers({
  paymentMethod,
  paymentProfileForm
})

export default reducer
